module.exports = __webpack_public_path__ + "static/img/cinema-14.17d55d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/png-img/cinema-14.png
// module id = 1384
// module chunks = 4